$(document).on('click', '.js-tabsList li:not(.active), .js-tabLink:not(.active)', function () {
  const _this = $(this)
  const currentTab = _this
    .parents('.js-tabs')
    .find('.js-tab')
    .eq(_this.index())

  _this.addClass('active').siblings().removeClass('active')
  currentTab.siblings('.js-tab').hide()
  currentTab.show()
})
